import React from 'react';
import './PaymentCardSkeleton.scss';

interface PaymentCardSkeletonProps {
    count?: number;
}

const PaymentCardSkeleton: React.FC<PaymentCardSkeletonProps> = ({ count = 3 }) => {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="payment-card-skeleton">
                    {/* Popular tag skeleton */}
                    <div className="skeleton-popular-tag"></div>
                    
                    <div className="skeleton-plan-content-wrapper">
                        {/* Plan details skeleton */}
                        <div className="skeleton-plan-details">
                            <div className="skeleton-plan-name"></div>
                            <div className="skeleton-plan-tag"></div>
                            <div className="skeleton-plan-description"></div>
                            <div className="skeleton-plan-description-short"></div>
                        </div>

                        {/* Price wrapper skeleton */}
                        <div className="skeleton-price-wrapper">
                            <div className="skeleton-price"></div>
                        </div>

                        {/* Button skeleton */}
                        <div className="skeleton-footer-wrapper">
                            <div className="skeleton-button"></div>
                        </div>

                        {/* Feature list skeleton */}
                        <div className="skeleton-feature-list">
                            {Array.from({ length: 6 }).map((_, featureIndex) => (
                                <div key={featureIndex} className="skeleton-feature-wrapper">
                                    <div className="skeleton-check-icon"></div>
                                    <div className="skeleton-feature-text"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default PaymentCardSkeleton;
